class Employee {
	async getAllByCompany(id) {
		const response = await fetch(`${process.env.REACT_APP_API}/ee/employee/list/${id}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		})
		return response.json()
	}
}

export default new Employee()
